import React, { Fragment } from 'react';
import { Divider, Form } from 'antd';
import { object, func, string } from 'prop-types';

import { SvgIcon } from '../../components/svg-icon';
import { AssignButton } from '../../components/ui-helpers';
import { getAvatarUrl, filterOption, getCurrentUserId } from '../../utils';

import {
  Title,
  SelectS,
  FormItem,
  ButtonSave,
  FieldWrapper,
  StyledOption,
  ButtonWrapper,
  UserImageWrap,
} from './styled-components';

const AssignUserForm = ({
  form: { getFieldDecorator, setFieldsValue },
  onSubmitForm,
  users,
  title,
  selectedUser,
  setSelectedUser,
}) => (
  <Fragment>
    <Title>{title}</Title>
    <Form onSubmit={onSubmitForm}>
      <FieldWrapper>
        <AssignButton
          type="button"
          disabled={selectedUser === getCurrentUserId()}
          onClick={() => {
            setSelectedUser(getCurrentUserId());
            setFieldsValue({ userId: getCurrentUserId() });
          }}
        >
          <SvgIcon type="plus" /> Assign me
        </AssignButton>
        <FormItem colon={false} label="Responsible User">
          {getFieldDecorator('userId', {
            initialValue: selectedUser,
            rules: [
              {
                required: true,
                message: 'Please choose responsible user...',
              },
            ],
          })(<SelectS
            showSearch
            size="large"
            allowClear
            placeholder="Choose responsible User..."
            defaultActiveFirstOption={false}
            onChange={setSelectedUser}
            filterOption={filterOption}
            getPopupContainer={triggerNode => triggerNode.parentNode}
          >
            {Object.values(users).map(user => (
              <StyledOption
                key={user._id}
                value={user._id}
                hidden={!user.isActivated}
              >
                <UserImageWrap
                  width={24}
                  height={24}
                  src={getAvatarUrl(user.profileImage)}
                />
                {user.fullName} <Divider type="vertical" /> {user.email}
              </StyledOption>
            ))}
          </SelectS>)}
        </FormItem>
      </FieldWrapper>

      <ButtonWrapper>
        <ButtonSave key="submit" type="primary" htmlType="submit">
          Save
        </ButtonSave>
      </ButtonWrapper>
    </Form>
  </Fragment>
);

AssignUserForm.propTypes = {
  title: string.isRequired,
  form: object.isRequired,
  users: object,
  selectedUser: string,
  onSubmitForm: func.isRequired,
  setSelectedUser: func.isRequired,
};

AssignUserForm.defaultProps = {
  users: {},
  selectedUser: undefined,
};

export default AssignUserForm;



// WEBPACK FOOTER //
// ./src/modals/assign-user-modal/component.js